(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1715],{

/***/ 96808:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "QS": function() { return /* binding */ useSwipeable; }
/* harmony export */ });
/* unused harmony exports DOWN, LEFT, RIGHT, UP */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32466);


const LEFT = "Left";
const RIGHT = "Right";
const UP = "Up";
const DOWN = "Down";

/* global document */
const defaultProps = {
    delta: 10,
    preventScrollOnSwipe: false,
    rotationAngle: 0,
    trackMouse: false,
    trackTouch: true,
    swipeDuration: Infinity,
    touchEventOptions: { passive: true },
};
const initialState = {
    first: true,
    initial: [0, 0],
    start: 0,
    swiping: false,
    xy: [0, 0],
};
const mouseMove = "mousemove";
const mouseUp = "mouseup";
const touchEnd = "touchend";
const touchMove = "touchmove";
const touchStart = "touchstart";
function getDirection(absX, absY, deltaX, deltaY) {
    if (absX > absY) {
        if (deltaX > 0) {
            return RIGHT;
        }
        return LEFT;
    }
    else if (deltaY > 0) {
        return DOWN;
    }
    return UP;
}
function rotateXYByAngle(pos, angle) {
    if (angle === 0)
        return pos;
    const angleInRadians = (Math.PI / 180) * angle;
    const x = pos[0] * Math.cos(angleInRadians) + pos[1] * Math.sin(angleInRadians);
    const y = pos[1] * Math.cos(angleInRadians) - pos[0] * Math.sin(angleInRadians);
    return [x, y];
}
function getHandlers(set, handlerProps) {
    const onStart = (event) => {
        const isTouch = "touches" in event;
        // if more than a single touch don't track, for now...
        if (isTouch && event.touches.length > 1)
            return;
        set((state, props) => {
            // setup mouse listeners on document to track swipe since swipe can leave container
            if (props.trackMouse && !isTouch) {
                document.addEventListener(mouseMove, onMove);
                document.addEventListener(mouseUp, onUp);
            }
            const { clientX, clientY } = isTouch ? event.touches[0] : event;
            const xy = rotateXYByAngle([clientX, clientY], props.rotationAngle);
            props.onTouchStartOrOnMouseDown &&
                props.onTouchStartOrOnMouseDown({ event });
            return Object.assign(Object.assign(Object.assign({}, state), initialState), { initial: xy.slice(), xy, start: event.timeStamp || 0 });
        });
    };
    const onMove = (event) => {
        set((state, props) => {
            const isTouch = "touches" in event;
            // Discount a swipe if additional touches are present after
            // a swipe has started.
            if (isTouch && event.touches.length > 1) {
                return state;
            }
            // if swipe has exceeded duration stop tracking
            if (event.timeStamp - state.start > props.swipeDuration) {
                return state.swiping ? Object.assign(Object.assign({}, state), { swiping: false }) : state;
            }
            const { clientX, clientY } = isTouch ? event.touches[0] : event;
            const [x, y] = rotateXYByAngle([clientX, clientY], props.rotationAngle);
            const deltaX = x - state.xy[0];
            const deltaY = y - state.xy[1];
            const absX = Math.abs(deltaX);
            const absY = Math.abs(deltaY);
            const time = (event.timeStamp || 0) - state.start;
            const velocity = Math.sqrt(absX * absX + absY * absY) / (time || 1);
            const vxvy = [deltaX / (time || 1), deltaY / (time || 1)];
            const dir = getDirection(absX, absY, deltaX, deltaY);
            // if swipe is under delta and we have not started to track a swipe: skip update
            const delta = typeof props.delta === "number"
                ? props.delta
                : props.delta[dir.toLowerCase()] ||
                    defaultProps.delta;
            if (absX < delta && absY < delta && !state.swiping)
                return state;
            const eventData = {
                absX,
                absY,
                deltaX,
                deltaY,
                dir,
                event,
                first: state.first,
                initial: state.initial,
                velocity,
                vxvy,
            };
            // call onSwipeStart if present and is first swipe event
            eventData.first && props.onSwipeStart && props.onSwipeStart(eventData);
            // call onSwiping if present
            props.onSwiping && props.onSwiping(eventData);
            // track if a swipe is cancelable (handler for swiping or swiped(dir) exists)
            // so we can call preventDefault if needed
            let cancelablePageSwipe = false;
            if (props.onSwiping ||
                props.onSwiped ||
                props[`onSwiped${dir}`]) {
                cancelablePageSwipe = true;
            }
            if (cancelablePageSwipe &&
                props.preventScrollOnSwipe &&
                props.trackTouch &&
                event.cancelable) {
                event.preventDefault();
            }
            return Object.assign(Object.assign({}, state), { 
                // first is now always false
                first: false, eventData, swiping: true });
        });
    };
    const onEnd = (event) => {
        set((state, props) => {
            let eventData;
            if (state.swiping && state.eventData) {
                // if swipe is less than duration fire swiped callbacks
                if (event.timeStamp - state.start < props.swipeDuration) {
                    eventData = Object.assign(Object.assign({}, state.eventData), { event });
                    props.onSwiped && props.onSwiped(eventData);
                    const onSwipedDir = props[`onSwiped${eventData.dir}`];
                    onSwipedDir && onSwipedDir(eventData);
                }
            }
            else {
                props.onTap && props.onTap({ event });
            }
            props.onTouchEndOrOnMouseUp && props.onTouchEndOrOnMouseUp({ event });
            return Object.assign(Object.assign(Object.assign({}, state), initialState), { eventData });
        });
    };
    const cleanUpMouse = () => {
        // safe to just call removeEventListener
        document.removeEventListener(mouseMove, onMove);
        document.removeEventListener(mouseUp, onUp);
    };
    const onUp = (e) => {
        cleanUpMouse();
        onEnd(e);
    };
    /**
     * The value of passive on touchMove depends on `preventScrollOnSwipe`:
     * - true => { passive: false }
     * - false => { passive: true } // Default
     *
     * NOTE: When preventScrollOnSwipe is true, we attempt to call preventDefault to prevent scroll.
     *
     * props.touchEventOptions can also be set for all touch event listeners,
     * but for `touchmove` specifically when `preventScrollOnSwipe` it will
     * supersede and force passive to false.
     *
     */
    const attachTouch = (el, props) => {
        let cleanup = () => { };
        if (el && el.addEventListener) {
            const baseOptions = Object.assign(Object.assign({}, defaultProps.touchEventOptions), props.touchEventOptions);
            // attach touch event listeners and handlers
            const tls = [
                [touchStart, onStart, baseOptions],
                // preventScrollOnSwipe option supersedes touchEventOptions.passive
                [
                    touchMove,
                    onMove,
                    Object.assign(Object.assign({}, baseOptions), (props.preventScrollOnSwipe ? { passive: false } : {})),
                ],
                [touchEnd, onEnd, baseOptions],
            ];
            tls.forEach(([e, h, o]) => el.addEventListener(e, h, o));
            // return properly scoped cleanup method for removing listeners, options not required
            cleanup = () => tls.forEach(([e, h]) => el.removeEventListener(e, h));
        }
        return cleanup;
    };
    const onRef = (el) => {
        // "inline" ref functions are called twice on render, once with null then again with DOM element
        // ignore null here
        if (el === null)
            return;
        set((state, props) => {
            // if the same DOM el as previous just return state
            if (state.el === el)
                return state;
            const addState = {};
            // if new DOM el clean up old DOM and reset cleanUpTouch
            if (state.el && state.el !== el && state.cleanUpTouch) {
                state.cleanUpTouch();
                addState.cleanUpTouch = void 0;
            }
            // only attach if we want to track touch
            if (props.trackTouch && el) {
                addState.cleanUpTouch = attachTouch(el, props);
            }
            // store event attached DOM el for comparison, clean up, and re-attachment
            return Object.assign(Object.assign(Object.assign({}, state), { el }), addState);
        });
    };
    // set ref callback to attach touch event listeners
    const output = {
        ref: onRef,
    };
    // if track mouse attach mouse down listener
    if (handlerProps.trackMouse) {
        output.onMouseDown = onStart;
    }
    return [output, attachTouch];
}
function updateTransientState(state, props, previousProps, attachTouch) {
    // if trackTouch is off or there is no el, then remove handlers if necessary and exit
    if (!props.trackTouch || !state.el) {
        if (state.cleanUpTouch) {
            state.cleanUpTouch();
        }
        return Object.assign(Object.assign({}, state), { cleanUpTouch: undefined });
    }
    // trackTouch is on, so if there are no handlers attached, attach them and exit
    if (!state.cleanUpTouch) {
        return Object.assign(Object.assign({}, state), { cleanUpTouch: attachTouch(state.el, props) });
    }
    // trackTouch is on and handlers are already attached, so if preventScrollOnSwipe changes value,
    // remove and reattach handlers (this is required to update the passive option when attaching
    // the handlers)
    if (props.preventScrollOnSwipe !== previousProps.preventScrollOnSwipe ||
        props.touchEventOptions.passive !== previousProps.touchEventOptions.passive) {
        state.cleanUpTouch();
        return Object.assign(Object.assign({}, state), { cleanUpTouch: attachTouch(state.el, props) });
    }
    return state;
}
function useSwipeable(options) {
    const { trackMouse } = options;
    const transientState = react__WEBPACK_IMPORTED_MODULE_0__.useRef(Object.assign({}, initialState));
    const transientProps = react__WEBPACK_IMPORTED_MODULE_0__.useRef(Object.assign({}, defaultProps));
    // track previous rendered props
    const previousProps = react__WEBPACK_IMPORTED_MODULE_0__.useRef(Object.assign({}, transientProps.current));
    previousProps.current = Object.assign({}, transientProps.current);
    // update current render props & defaults
    transientProps.current = Object.assign(Object.assign({}, defaultProps), options);
    // Force defaults for config properties
    let defaultKey;
    for (defaultKey in defaultProps) {
        if (transientProps.current[defaultKey] === void 0) {
            transientProps.current[defaultKey] = defaultProps[defaultKey];
        }
    }
    const [handlers, attachTouch] = react__WEBPACK_IMPORTED_MODULE_0__.useMemo(() => getHandlers((stateSetter) => (transientState.current = stateSetter(transientState.current, transientProps.current)), { trackMouse }), [trackMouse]);
    transientState.current = updateTransientState(transientState.current, transientProps.current, previousProps.current, attachTouch);
    return handlers;
}


//# sourceMappingURL=index.js.map


/***/ }),

/***/ 9561:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/download",
      function () {
        return __webpack_require__(24520);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 84661:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93288);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32466);


const SkipSection = (param)=>{
    let { children , hrefs , style  } = param;
    const handleSpaceAndEnter = ()=>{
        for(let i = 0; i < hrefs.length; i += 1){
            const href = hrefs[i];
            const el = document.getElementById(href); // scroll to first element in hrefs found in DOM
            if (el) {
                window.location.href = "#".concat(href);
                el.focus();
                break;
            }
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
        className: "pos-a-f bg-white gray800 ph4 pv3 br5 showOnFocus focus-bsDarkBlue3 brdn",
        style: style,
        onClick: handleSpaceAndEnter,
        children: children
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SkipSection);


/***/ }),

/***/ 97455:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93288);
/* harmony import */ var _c10h_colors__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(45602);
/* harmony import */ var _components_SkipSection__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(84661);
/* harmony import */ var ni18n__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(76361);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(32466);
/* harmony import */ var react_swipeable__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(96808);
/* harmony import */ var src_store__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(40367);
/* harmony import */ var _hooks_useClientSideId__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(33437);
/* harmony import */ var _useMediaQuery__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(57974);
/* harmony import */ var _common_constants__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(93932);
/* harmony import */ var _common_Carbon__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(29946);











const TestimonialSlider = (param)=>{
    let { defaultTestimons , defaultHead , autoRotate , firstBgColor , firstTextColor , smallFont =false , ariaLabel  } = param;
    const [k, setK] = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(0);
    const i18n = (0,ni18n__WEBPACK_IMPORTED_MODULE_2__/* .useTranslation */ .$G)();
    const { isMobile  } = (0,src_store__WEBPACK_IMPORTED_MODULE_4__/* .useTypedSelector */ .ix)((param)=>{
        let { config  } = param;
        return config;
    });
    (0,_common_Carbon__WEBPACK_IMPORTED_MODULE_8__/* .useInterval */ .Yz)(()=>{
        if ((autoRotate || isMobile) && !_common_constants__WEBPACK_IMPORTED_MODULE_7__/* .isCI */ .yg) {
            setK((k + 1) % testimons.length);
        }
    }, 8000, false);
    const head = defaultHead || i18n.t("What our patients say");
    const testimons = defaultTestimons || [
        {
            body: i18n.t("I highly recommend them to anyone needing medical attention. Reservations are easy to set up via their app and recommended to avoid wait time. Yelp only allows for 5 stars. I would give them a 10."),
            who: {
                name: "Gary",
                who: i18n.t("Carbon Health San Francisco Patient")
            },
            bg: firstBgColor || _c10h_colors__WEBPACK_IMPORTED_MODULE_9__.darkerMint,
            color: firstTextColor || "#fff"
        },
        {
            body: i18n.t("Oh my God, finally an urgent care in our neighborhood that doesn't actually feel like an urgent care!  The space is super clean, modern, open and airy. The staff was excellent and were super friendly."),
            who: {
                name: "Gina",
                who: i18n.t("Carbon Health Los Angeles Patient")
            },
            bg: _c10h_colors__WEBPACK_IMPORTED_MODULE_9__.darkPurple,
            color: "#fff"
        },
        {
            body: i18n.t("If I could give this place 10 stars, I would. I received exceptional service from the moment I walked in, to the time I left. This place has been the best urgent care location I've ever been to."),
            who: {
                name: "Steph",
                who: i18n.t("Carbon Health San Jose Patient")
            },
            bg: _c10h_colors__WEBPACK_IMPORTED_MODULE_9__.darkerYellow
        },
        {
            body: i18n.t("Literally amazing. They have the nicest doctors and staff, and you can get an appointment so easily and so fast! "),
            who: {
                name: "Liana",
                who: i18n.t("Carbon Health San Francisco Patient")
            },
            bg: _c10h_colors__WEBPACK_IMPORTED_MODULE_9__.darkBlue
        },
        {
            body: i18n.t("Appreciated being seen immediately, the friendly and helpful staff, and my comprehensive care including x-rays, prescriptions called into my pharmacy and scheduling a follow-up appointment."),
            who: {
                name: "Laurie",
                who: i18n.t("Carbon Health Oakland Patient")
            },
            bg: _c10h_colors__WEBPACK_IMPORTED_MODULE_9__.darkerMint
        },
        {
            body: i18n.t("What I love is through their app (make sure you download the app - worth it) they check up on you to make sure you are ok. You are able to share any new developments."),
            who: {
                name: "Joeletta",
                who: i18n.t("Carbon Health Mountain View Patient")
            },
            bg: _c10h_colors__WEBPACK_IMPORTED_MODULE_9__.darkPurple
        },
        {
            body: i18n.t("Great urgent care! Easy to make an appointment, got seen right away, the place was clean and tidy, and the staff was extremely friendly and helpful."),
            who: {
                name: "Tessa",
                who: i18n.t("Carbon Health Berkeley Patient")
            },
            bg: _c10h_colors__WEBPACK_IMPORTED_MODULE_9__.darkerYellow
        }
    ];
    const activeItem = testimons[k];
    const swipeHandlers = (0,react_swipeable__WEBPACK_IMPORTED_MODULE_10__/* .useSwipeable */ .QS)({
        onSwipedRight: ()=>isMobile && changeSlide(-1),
        onSwipedLeft: ()=>isMobile && changeSlide(1)
    });
    const changeSlide = (val)=>{
        const nextVal = k + val > testimons.length - 1 ? 0 : k + val < 0 ? testimons.length - 1 : k + val;
        setK(nextVal);
    };
    const isXs = (0,_useMediaQuery__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)("xs");
    const headingId = (0,_hooks_useClientSideId__WEBPACK_IMPORTED_MODULE_5__/* .useClientSideId */ .i)();
    const carouselId = (0,_hooks_useClientSideId__WEBPACK_IMPORTED_MODULE_5__/* .useClientSideId */ .i)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
        className: "lg:py-36 md:py-16 pt-16 pb-10 relative text-white contrast-tbt max-w-screen transition-colors duration-500",
        style: {
            backgroundColor: testimons[k].bg
        },
        "aria-labelledby": headingId,
        "aria-roledescription": "carousel",
        ...ariaLabel && {
            "aria-label": ariaLabel
        },
        ...swipeHandlers,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "relative m-auto px-4 md:px-24",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_SkipSection__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                    hrefs: [
                        "explore-locations",
                        "footer"
                    ],
                    style: {
                        left: "2rem",
                        top: "-4rem"
                    },
                    children: i18n.t("Skip Carousel")
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    children: [
                        !activeItem.hideHeadTitle && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                            className: "font-ir fs13 op1 ls2 mb8 mt0 ttu",
                            id: headingId,
                            children: activeItem.head || head
                        }),
                        activeItem.headImg && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "mb8 minh20",
                            children: activeItem.headImg
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "relative overflow-hidden",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "transition-transform duration-500 grid grid-flow-col",
                                style: {
                                    gridAutoColumns: "100%",
                                    transform: "translateX(".concat(-100 * k, "%)")
                                },
                                id: carouselId,
                                "aria-live": autoRotate || isMobile ? "off" : "polite",
                                children: testimons.map((t, i)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("blockquote", {
                                        className: "t-op200 pos-r df fdc op0 brdn pl0 m0 ".concat(i === k ? "op1" : ""),
                                        role: "group",
                                        "aria-label": i18n.t(" {{number}} of {{total}}", {
                                            number: i + 1,
                                            total: testimons.length
                                        }),
                                        "aria-hidden": i !== k,
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                className: "font-cm mb8 ".concat(smallFont ? "fs28 fs18-md" : "fs40 fs24-md", " lh12 lh14-md maxw64 pb24 pb16-md fx"),
                                                children: t.body
                                            }),
                                            t.who && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "font-cm fs20 fs18-md mb2",
                                                children: t.who.name
                                            }),
                                            t.who && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "font-cm fs20 fs18-md lh14 maxw12-md",
                                                children: t.who.who
                                            }),
                                            t.source && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                href: t.source,
                                                rel: "noopener noreferrer",
                                                target: "_blank",
                                                className: "white fs14 font-ir us pos-a",
                                                style: {
                                                    bottom: 0
                                                },
                                                children: i18n.t("Source")
                                            })
                                        ]
                                    }, i))
                            })
                        })
                    ]
                }),
                testimons.length > 1 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "df aic pos-a pos-r-xs mt4-xs",
                    style: isXs ? {} : {
                        right: "2rem",
                        bottom: isMobile ? ".25rem" : "-1rem"
                    },
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "font-mb fs12 mr6 ttu",
                            children: i18n.t(" {{number}} of {{total}}", {
                                number: k + 1,
                                total: testimons.length
                            })
                        }),
                        !isMobile && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                    style: {
                                        backgroundColor: _c10h_colors__WEBPACK_IMPORTED_MODULE_9__.darkerGreen + 33
                                    },
                                    onClick: ()=>changeSlide(-1),
                                    className: "cp br50 p2 fs36 cIcon-arrow-left mr4 brdn white contrast-tb",
                                    "aria-controls": carouselId,
                                    "aria-label": i18n.t("Previous")
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                    style: {
                                        backgroundColor: _c10h_colors__WEBPACK_IMPORTED_MODULE_9__.darkerGreen + 33
                                    },
                                    onClick: ()=>changeSlide(1),
                                    className: "cp br50 p2 fs36 cIcon-arrow-right2 brdn white contrast-tb",
                                    "aria-controls": carouselId,
                                    "aria-label": i18n.t("Next")
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (TestimonialSlider);


/***/ }),

/***/ 30545:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ TextMeApp; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(93288);
// EXTERNAL MODULE: ./src/utils/fetch/fetches.ts + 2 modules
var fetches = __webpack_require__(54428);
;// CONCATENATED MODULE: ./src/_services/website/downloadLink.ts

const sendDownloadLink = async (param)=>{
    let { phone , practiceSlug , csrfToken , captcha  } = param;
    const response = await (0,fetches/* nextApi */.t)()("/api/download-link", {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "CSRF-Token": csrfToken || "null"
        },
        credentials: "same-origin",
        body: JSON.stringify({
            phone,
            practiceSlug,
            captcha
        })
    });
    return response.json();
};

// EXTERNAL MODULE: ./src/i18n.ts + 5 modules
var src_i18n = __webpack_require__(76361);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(32466);
// EXTERNAL MODULE: ./node_modules/react-google-recaptcha/lib/esm/index.js + 3 modules
var esm = __webpack_require__(62276);
// EXTERNAL MODULE: ./node_modules/react-intl-tel-input/dist/index.js
var dist = __webpack_require__(18462);
// EXTERNAL MODULE: ./src/store/index.ts + 6 modules
var store = __webpack_require__(40367);
// EXTERNAL MODULE: ./src/components/_common/Carbon.tsx
var Carbon = __webpack_require__(29946);
// EXTERNAL MODULE: ./src/components/v5/TextMeApp.module.scss
var TextMeApp_module = __webpack_require__(60391);
var TextMeApp_module_default = /*#__PURE__*/__webpack_require__.n(TextMeApp_module);
;// CONCATENATED MODULE: ./src/components/v5/TextMeApp.tsx









var SubmitStatus;
(function(SubmitStatus) {
    SubmitStatus[SubmitStatus["WAITING"] = 0] = "WAITING";
    SubmitStatus[SubmitStatus["SENT"] = 1] = "SENT";
    SubmitStatus[SubmitStatus["ERROR"] = 2] = "ERROR";
})(SubmitStatus || (SubmitStatus = {}));
const TextmeApp = (param)=>{
    let { downloadDeepLink , practiceSlug , gA , action ="Download app" , inputStyle ={}  } = param;
    const { isMobile , recaptchaClientKey , csrfToken  } = (0,store/* useTypedSelector */.ix)((param)=>{
        let { config  } = param;
        return config;
    });
    const i18n = (0,src_i18n/* useTranslation */.$G)();
    const recaptchaRef = (0,react.useRef)(null);
    const [submitStatus, setSubmitStatus] = (0,react.useState)(SubmitStatus.WAITING);
    const [phoneNumber, setPhoneNumber] = (0,react.useState)(null);
    const getPhone = ()=>{
        var _document_getElementById;
        return (_document_getElementById = document.getElementById("phone-number-input")) === null || _document_getElementById === void 0 ? void 0 : _document_getElementById.getElementsByClassName("phone")[0];
    };
    (0,react.useEffect)(()=>{
        const phone = getPhone();
        if (phone) {
            phone.setAttribute("required", "true");
        }
    }, []);
    const handleSubmit = async (e)=>{
        e.preventDefault();
        const captcha = recaptchaRef.current ? await recaptchaRef.current.executeAsync() : null;
        sendDownloadLink({
            phone: phoneNumber,
            practiceSlug,
            csrfToken,
            captcha
        }).then(()=>{
            setSubmitStatus(SubmitStatus.SENT);
            (0,Carbon/* trackToPatient */.Zr)({
                ga: {
                    category: "Download app",
                    action,
                    label: "download"
                }
            });
        }).catch(()=>{
            setSubmitStatus(SubmitStatus.ERROR);
        });
    };
    const handlePhoneNumberChange = (status, _value, _countryData, number)=>{
        const phone = getPhone();
        if (status && phone) {
            phone.removeAttribute("pattern");
        } else if (phone) {
            phone.setAttribute("required", "true");
            phone.setAttribute("pattern", "abc");
        }
        setPhoneNumber(number);
    };
    return isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (TextMeApp_module_default()).mobile,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
            href: downloadDeepLink,
            className: (TextMeApp_module_default()).downlaodBtn,
            onClick: ()=>gA && gA(),
            children: i18n.t("Get the Carbon Health App")
        })
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: submitStatus === SubmitStatus.WAITING ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
            id: "phone-number-input",
            onSubmit: handleSubmit,
            className: (TextMeApp_module_default()).form,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                    autoPlaceholder: false,
                    inputClassName: "phone",
                    defaultCountry: "us",
                    placeholder: i18n.t("Phone number"),
                    format: true,
                    style: inputStyle,
                    onPhoneNumberChange: handlePhoneNumberChange
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                    className: "".concat((TextMeApp_module_default()).btn, " btn btn-genoa"),
                    type: "submit",
                    children: i18n.t("Text Me the App")
                }),
                recaptchaClientKey ? /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* default */.Z, {
                    ref: recaptchaRef,
                    sitekey: recaptchaClientKey,
                    size: "invisible"
                }) : null
            ]
        }) : submitStatus === SubmitStatus.ERROR ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "btn pen",
                    children: i18n.t("Something went wrong!")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                    className: "color-brand di brdn bg-inherit cp us font-cm",
                    onClick: ()=>setSubmitStatus(SubmitStatus.WAITING),
                    children: i18n.t("Try again.")
                })
            ]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "btn btn-genoa pen df aic",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "cIcon-check-rounded fs14 mr2 gray50 di"
                        }),
                        i18n.t("Text Sent Successfully!")
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                    className: "mt4",
                    children: [
                        i18n.t("It didn't work?"),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            className: "color-brand di brdn bg-inherit cp us font-cm",
                            onClick: ()=>setSubmitStatus(SubmitStatus.WAITING),
                            children: i18n.t("Try again.")
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var TextMeApp = (TextmeApp);


/***/ }),

/***/ 24520:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ download; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(93288);
// EXTERNAL MODULE: ./src/i18n.ts + 5 modules
var src_i18n = __webpack_require__(76361);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(32466);
// EXTERNAL MODULE: ./src/store/index.ts + 6 modules
var store = __webpack_require__(40367);
// EXTERNAL MODULE: ./src/_services/api.ts + 2 modules
var api = __webpack_require__(95832);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(21395);
// EXTERNAL MODULE: ./src/constants/practiceIds.ts
var practiceIds = __webpack_require__(34557);
// EXTERNAL MODULE: ./src/utils/ignoreArrays.ts
var ignoreArrays = __webpack_require__(1146);
// EXTERNAL MODULE: ./src/components/_common/Carbon.tsx
var Carbon = __webpack_require__(29946);
// EXTERNAL MODULE: ./src/components/v5/NextImage.tsx + 1 modules
var NextImage = __webpack_require__(5621);
// EXTERNAL MODULE: ./src/components/v5/TextMeApp.tsx + 1 modules
var TextMeApp = __webpack_require__(30545);
// EXTERNAL MODULE: ./src/components/v5/Download/Main.module.scss
var Main_module = __webpack_require__(6753);
var Main_module_default = /*#__PURE__*/__webpack_require__.n(Main_module);
;// CONCATENATED MODULE: ./src/components/v5/Download/Main.tsx












const Main = (param)=>{
    let { gA  } = param;
    const { practices , isMobile  } = (0,store/* useTypedSelector */.ix)((param)=>{
        let { config  } = param;
        return config;
    });
    const router = (0,next_router.useRouter)();
    const i18n = (0,src_i18n/* useTranslation */.$G)();
    const carbonPractice = practices === null || practices === void 0 ? void 0 : practices.findById(practiceIds/* PracticeId.CARBON */.I.CARBON);
    const [practice, setPractice] = (0,react.useState)(carbonPractice);
    const features = [
        {
            icon: "calendar",
            copy: i18n.t("Book same-day appointments"),
            color: "#A3E1C2",
            bg: "#A3E1C2",
            activeColor: "#19191b"
        },
        {
            icon: "medical-app",
            copy: i18n.t("Own your digital medical records"),
            color: "#EBC627",
            bg: "#EBC627",
            activeColor: "#19191b"
        },
        {
            icon: "icon_video",
            copy: i18n.t("Chat or video call your doc"),
            color: "#E15C18",
            bg: "#E15C18",
            activeColor: "#fff"
        },
        {
            icon: "drugs-pills",
            copy: i18n.t("Fill your prescriptions"),
            color: "#58B3CA",
            bg: "#58B3CA",
            activeColor: "#fff"
        }
    ];
    const [selected, setSelected] = (0,react.useState)(features[0].icon);
    (0,Carbon/* useEffectAsync */.LX)(async ()=>{
        const { practiceSlug: practiceSlugQuery  } = router.query;
        const practiceSlug = (0,ignoreArrays/* ignoreArrays */.F)(practiceSlugQuery);
        if (practiceSlug && practiceSlug !== (carbonPractice === null || carbonPractice === void 0 ? void 0 : carbonPractice.slug)) {
            const newPractice = await (0,api/* fetchPracticeBySlug */.f4)(practiceSlug);
            if (newPractice.name) setPractice(newPractice);
        }
    }, []);
    const { downloadDeepLink , slug  } = practice || {
        downloadDeepLink: "https://crbn.app.link/nijKU2YXJH",
        slug: "direct-urgent-care"
    };
    const renderBall = (f)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            style: {
                "--color": f.color,
                "--bg": f.bg,
                "--activeColor": f.activeColor
            },
            className: "".concat((Main_module_default()).ball, " ").concat(selected === f.icon ? "active" : ""),
            onClick: ()=>setSelected(f.icon),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "".concat((Main_module_default()).icon, " cIcon-").concat(f.icon)
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: (Main_module_default()).title,
                    children: f.copy
                })
            ]
        }, f.icon);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (Main_module_default()).wrapper,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (Main_module_default()).top,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "color-nevada",
                        children: i18n.t("Available on iPhone and Android")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                        className: (Main_module_default()).header,
                        children: i18n.t("Get the Carbon Health App")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (Main_module_default()).formWrapper,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TextMeApp/* default */.Z, {
                            practiceSlug: slug,
                            downloadDeepLink: downloadDeepLink,
                            gA: gA
                        })
                    }),
                    !isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (Main_module_default()).wewill,
                        children: i18n.t("We will send you a link to download the Carbon Health app")
                    })
                ]
            }),
            !isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (Main_module_default()).bottom,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (Main_module_default()).bottomInner,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (Main_module_default()).bottomSide,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (Main_module_default()).ballWrapper,
                                children: features.slice(0, 2).map((f)=>renderBall(f))
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (Main_module_default()).bottomMiddle,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NextImage/* default */.Z, {
                                width: 460,
                                height: 874,
                                src: "download-phone",
                                priority: true,
                                alt: i18n.t("An iPhone showing a patient's next appointment.")
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (Main_module_default()).bottomSide,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (Main_module_default()).ballWrapper,
                                children: features.slice(2, 4).map(renderBall)
                            })
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var Download_Main = (Main);

// EXTERNAL MODULE: ./src/components/v5/Layout.tsx + 29 modules
var Layout = __webpack_require__(32122);
// EXTERNAL MODULE: ./src/components/v5/TestimonialSlider.tsx
var TestimonialSlider = __webpack_require__(97455);
// EXTERNAL MODULE: ./src/pages/download.module.scss
var download_module = __webpack_require__(72338);
var download_module_default = /*#__PURE__*/__webpack_require__.n(download_module);
;// CONCATENATED MODULE: ./src/pages/download.tsx









// export const config = {amp: "hybrid"};
const Download = ()=>{
    const i18n = (0,src_i18n/* useTranslation */.$G)();
    const { isMobile  } = (0,store/* useTypedSelector */.ix)((param)=>{
        let { config  } = param;
        return config;
    });
    const gA = ()=>isMobile ? (0,api.GA)({
            category: "Download app",
            action: "Branch Link from DL page",
            label: ""
        }) : (0,api.GA)({
            category: "Download app",
            action: "SMS from DL page",
            label: ""
        });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Layout/* default */.Z, {
        className: (download_module_default()).download,
        pageTitle: i18n.t("Download | Carbon Health"),
        pageDescription: i18n.t("Download | Providing High-Quality Adult & Pediatric Urgent Care both virtually or at one of our physical clinics in California and Nevada."),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Download_Main, {
                gA
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TestimonialSlider/* default */.Z, {})
        ]
    });
};
/* harmony default export */ var download = (Download);


/***/ }),

/***/ 6753:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Main_wrapper__5uc8M","top":"Main_top__gklJz","header":"Main_header__rrdsz","formWrapper":"Main_formWrapper__v6Jn1","wewill":"Main_wewill__iHhB7","bottom":"Main_bottom__E4kmt","bottomInner":"Main_bottomInner__JGghA","bottomMiddle":"Main_bottomMiddle__mfMtQ","ballWrapper":"Main_ballWrapper__Egpxx","ball":"Main_ball__VfgwQ","icon":"Main_icon__eTWXC","title":"Main_title__LtbNC"};

/***/ }),

/***/ 60391:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"form":"TextMeApp_form__DD_b8","btn":"TextMeApp_btn__X5Y8U","mobile":"TextMeApp_mobile__ItCrX","downlaodBtn":"TextMeApp_downlaodBtn__FZmVn"};

/***/ }),

/***/ 72338:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"download":"download_download__p_IjH","left":"download_left__wnj_U","right":"download_right__owVeb","iphone":"download_iphone__ChXPQ","iphoneInner":"download_iphoneInner__1zLuR","hide-in-tablet":"download_hide-in-tablet__6lQ4e","deep-wrapper":"download_deep-wrapper__klUf6","wrapper":"download_wrapper__6yJqv","download-copy":"download_download-copy__GSSVC","icons":"download_icons__2iPif","inner-icons":"download_inner-icons__9fLAc","textme-wrapper":"download_textme-wrapper__0U_Hx","layout":"download_layout__g6qKM","inner":"download_inner__1d3aE","inner-logo":"download_inner-logo__hScVq"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2745,3014,1439,6282,2122,9774,2888,179], function() { return __webpack_exec__(9561); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);